import React from "react";
import RadioGroup from "../components/RadioGroup";
import { permissions } from "../utils/permissions";
import { Divider } from "antd";

export default function Permissions({ checkedList, setCheckedList }) {
  return (
    <div>
      <strong>Permissions</strong>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "left",
          marginBottom: "10px",
        }}
      >
        {permissions.map((x, index) => (
          <div key={index} style={{ marginBottom: "10px" }}>
            <Divider orientation="left">{x.label}</Divider>
            <RadioGroup
              label={x.label}
              list={x.list}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
